export default function extractSliderName(str) {
  const regex = /{{([a-zA-Z0-9_-]+)-slider}}/g; // регулярное выражение
  const match = regex.exec(str); // поиск совпадений в строке
  return match ? match[1] : null; // возвращаем имя или null, если не найдено
}
